module.exports = __webpack_public_path__ + "static/media/gen_oth_haz_lev.64efd649.png";